import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { t } from "../../i18next"

export class UnsentCasesNavigator extends Component {
  static propTypes = {
    nofCases: PropTypes.number,
  }

  render() {
    const { nofCases } = this.props

    if (nofCases) {
      return (
        <Link to="/case/unsent" className="damage-case-unsent-cases-navigator">
          <div className="counter-circle">
            <div className="number">{nofCases}</div>
          </div>
          <div className="text">{t("damageCase.unsentCases.menuitem")}</div>
        </Link>
      )
    } else {
      return null
    }
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  const lang = state.auth.lang
  const nofCases = state.damageCase && Object.getOwnPropertyNames(state.damageCase.unsentCases).length

  return {
    lang,
    nofCases,
  }
}

export default connect(mapStateToProps)(UnsentCasesNavigator)



// WEBPACK FOOTER //
// ./src/features/damage-case/UnsentCasesNavigator.js